(() => {
  angular
    .module('gm.common.directives')
    .directive('btgMobileCameraButton', btgMobileCameraButtonDirective);

  function btgMobileCameraButtonDirective() {
    'ngInject';

    return {
      restrict: 'E',
      require: 'ngModel',
      transclude: true,
      template: `
        <span ngf-select
          ng-model="$sc.document"
          ngf-accept="$sc.fileTypes"
          ngf-resize="$sc.resize"
          ngf-resize-if="$sc.resizeCondition($width, $height)"
          ngf-capture="'camera'"><ng-transclude></ng-transclude>
        </span>`,

      link(scope, _element, _attrs, ctrl) {
        scope.document = null;

        scope.fileTypes = '.png,.jpg,.jpeg';
        scope.resize = {
          width: 1280,
          height: 960,
          quality: 0.8,
          type: 'image/jpeg',
          centerCrop: false
        };

        scope.resizeCondition = function _resizeCondition($width, $height) {
          return scope.resize.width < $width || scope.resize.height < $height;
        };

        scope.$watch('document', doc => ctrl.$setViewValue(doc));
        scope.$watch(() => ctrl.$viewValue, (doc) => { scope.document = doc; });
      }
    };
  }
})();
